import React from "react";
import Nav from "../componets/nav";
import "./pricing.css";

const Pricing = () => {
  const handleBookingClick = (packageType) => {
    // Trigger the booking modal from the navigation component
    const bookButton = document.querySelector(".book-button");
    if (bookButton) {
      bookButton.click();
    }
  };

  return (
    <div className="pricing-page">
      <Nav />
      <div className="pricing-container">
        <header className="pricing-hero">
          <h1 className="pricing-title">Pricing</h1>
          <p className="pricing-subtitle">
            Professional automotive photography packages tailored to your needs
          </p>
        </header>

        <div className="pricing-content">
          {/* Track Photography Package */}
          <div className="pricing-card featured">
            <div className="card-header">
              <h3>Track Photography</h3>
              <div className="price">
                <span className="currency">R</span>
                <span className="amount">9000</span>
                <span className="period">/day</span>
              </div>
            </div>
            <ul className="features-list">
              <li>✓ Full race day coverage</li>
              <li>✓ 50+ edited high-resolution images</li>
              <li>✓ Action shots during races</li>
              <li>✓ Pit lane and paddock coverage</li>
              <li>✓ Driver portrait sessions</li>
              <li>✓ Online gallery delivery</li>
            </ul>
            <button
              className="pricing-btn primary"
              onClick={() => handleBookingClick("Track Photography")}
            >
              Book Now
            </button>
          </div>

          {/* Commercial Work Package */}
          <div className="pricing-card premium">
            <div className="card-header">
              <h3>Commercial Work</h3>
              <div className="price">
                <span className="currency">R</span>
                <span className="amount">8000</span>
                <span className="period">/project</span>
              </div>
            </div>
            <ul className="features-list">
              <li>✓ Brand campaign photography</li>
              <li>✓ Unlimited edited images</li>
              <li>✓ Multi-location shoots</li>
              <li>✓ Model and talent coordination</li>
              <li>✓ Full commercial licensing</li>
              <li>✓ Raw file delivery</li>
              <li>✓ 30-day revision period</li>
            </ul>
            <button
              className="pricing-btn "
              onClick={() => handleBookingClick("Commercial Work")}
            >
              Book Now
            </button>
          </div>

          {/* Custom Shoots Package */}
          <div className="pricing-card">
            <div className="card-header">
              <h3>Custom Shoots</h3>
              <div className="price">
                <span className="currency">R</span>
                <span className="amount">2000</span>
                <span className="period">/session</span>
              </div>
            </div>
            <ul className="features-list">
              <li>✓ 2-hour personalized session</li>
              <li>✓ 25+ edited high-resolution images</li>
              <li>✓ Location scouting included</li>
              <li>✓ Multiple angle coverage</li>
              <li>✓ Interior and exterior shots</li>
              <li>✓ Lifestyle photography options</li>
              <li>✓ Rush delivery available</li>
            </ul>
            <button
              className="pricing-btn"
              onClick={() => handleBookingClick("Custom Shoots")}
            >
              Book Now
            </button>
          </div>

          {/* Car Shows & Exhibitions Package */}
          <div className="pricing-card">
            <div className="card-header">
              <h3>Car Shows & Exhibitions</h3>
              <div className="price">
                <span className="currency">R</span>
                <span className="amount">4500</span>
                <span className="period">/event</span>
              </div>
            </div>
            <ul className="features-list">
              <li>✓ Event coverage (up to 6 hours)</li>
              <li>✓ 30+ edited high-resolution images</li>
              <li>✓ Detail shots of featured vehicles</li>
              <li>✓ Crowd and atmosphere shots</li>
            </ul>
            <button
              className="pricing-btn"
              onClick={() => handleBookingClick("Car Shows & Exhibitions")}
            >
              Book Now
            </button>
          </div>
        </div>

        {/* Additional Services */}
        <div className="additional-services">
          <h2>Additional Services</h2>
          <div className="services-grid">
            <div className="service-item">
              <h4>Rush Delivery</h4>
              <p>24-hour delivery</p>
              <span className="service-price">+/-R500</span>
            </div>
            <div className="service-item">
              <h4>Extra Edits</h4>
              <p>Per additional image</p>
              <span className="service-price">R40</span>
            </div>
            <div className="service-item">
              <h4>Print Package</h4>
              <p>Professional prints delivered</p>
              <span className="service-price">Additional priced</span>
            </div>
            <div className="service-item">
              <h4>Social Media Package</h4>
              <p>Optimized for social platforms</p>
              <span className="service-price">R300</span>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="faq-section">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h4>What's included in the base price?</h4>
              <p>
                All packages include professional editing, high-resolution
                digital delivery. Travel within 30 Km is included.
              </p>
            </div>
            <div className="faq-item">
              <h4>How long does editing take?</h4>
              <p>
                Standard delivery is 5-7 business days. Rush delivery (24 hours)
                is available for an additional fee.
              </p>
            </div>
            <div className="faq-item">
              <h4>Do you travel for shoots?</h4>
              <p>
                Yes! Travel within 30Km is included. Longer distances available
                with travel fees discussed upfront.
              </p>
            </div>
            <div className="faq-item">
              <h4>Can I get raw files?</h4>
              <p>
                Raw files are available for commercial packages or as an add-on
                service for other packages.
              </p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="pricing-cta">
          <h2>You have a custom shoot in mind?</h2>
          <p>
            Let's discuss your photography needs and create something amazing
            together.
          </p>
          <button
            className="cta-button"
            onClick={() => handleBookingClick("General Inquiry")}
          >
            Contact Us Today
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
